'use strict';

var u = require('universalify').fromCallback;

module.exports = {
  copy: u(require('./copy'))
};